import { type UserManagerSettings, WebStorageStateStore } from "oidc-client-ts";

const getStorage = (prefix: string) => {
	try {
		return new WebStorageStateStore({
			prefix,
			store: window.localStorage,
		});
	} catch (err) {
		console.error(err);
		console.warn("using default oidc storage (sessions or in memory)");
		return undefined;
	}
};
const baseSettings = {
	response_type: "code",
	post_logout_redirect_uri: `${window.location.protocol}//${
		window.location.hostname
	}${window.location.port ? `:${window.location.port}` : ""}/logout`,
	silent_redirect_uri: `${window.location.protocol}//${
		window.location.hostname
	}${window.location.port ? `:${window.location.port}` : ""}/silent_renew`,
	automaticSilentRenew: true,
	loadUserInfo: true,
	scope: "openid profile email",
	userStore: getStorage("kultify_app_v1_"),
};

const generateOIDCSettings = (clientId: string): UserManagerSettings => {
	return {
		authority: "https://auth.kultifyapp.com",
		client_id: clientId,
		redirect_uri: `${window.location.protocol}//${
			window.location.hostname
		}${window.location.port ? `:${window.location.port}` : ""}/callback`,
		...baseSettings,
	};
};

const generateV2OIDCSettings = (clientId: string): UserManagerSettings => {
	return {
		authority: "https://login.dev.kultify.com",
		client_id: clientId,
		redirect_uri: `${window.location.protocol}//${
			window.location.hostname
		}${window.location.port ? `:${window.location.port}` : ""}/callback`,
		...baseSettings,
		userStore: getStorage("kultify_app_v2_"),
		//scope: "openid profile email urn:zitadel:iam:org:projects:roles",
	};
};
const ZITADEL_DEV_APP_CLIENT_ID = "333195638156103035";
const ZITADEL_PROD_APP_CLIENT_ID = "250134062625259522@kultifyapp";

const PROD_APP_ID = "651d995d-8ac2-4507-8e38-4105a56f8c7c";
const DEV_APP_ID = "1bb60807-6d0f-45f3-b54e-c33b2de4fb8c";

const isDevEnvironment =
	window.location.host.startsWith("dev.") ||
	window.location.host.includes("localhost");

function isAuthV2Enabled() {
	const isCypress = (window as any).Cypress || (window.parent as any).Cypress;
	return (
		(window.localStorage && localStorage.getItem("auth_v2") === "true") ||
		isCypress
	);
}
export function getOIDCConfig() {
	const authV2 = isAuthV2Enabled();
	console.log("oidc version", authV2 ? "v2" : "v1");
	if (isDevEnvironment) {
		return authV2
			? generateV2OIDCSettings(ZITADEL_DEV_APP_CLIENT_ID)
			: generateOIDCSettings(DEV_APP_ID);
	}
	return authV2
		? generateV2OIDCSettings(ZITADEL_PROD_APP_CLIENT_ID)
		: generateOIDCSettings(PROD_APP_ID);
}

export function getAuthorizationVersionHeader() {
	return isAuthV2Enabled() ? "v2" : "v1";
}
